import { ChargeVerificationSaveError } from './chargeVerificationSaveError';

export function getSaveErrorMessage(
  error: unknown,
  saveErrorText: string
): string {
  if (error instanceof ChargeVerificationSaveError) {
    return saveErrorText;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return String(error);
}
